export default "__VITE_ASSET__b28dfc7b__"